import * as THREE from 'three';
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';

function initCartGLB() {
  const cartLink = document.querySelector('.lookbook-cart-3d');
  const canvas = document.querySelector('#lookbook-cart-canvas');
  const badge = document.querySelector('#lookbook-cart-badge');

  if (!cartLink || !canvas) return;

  const emptyUrl = 'https://cdn.shopify.com/3d/models/f7c49a0cb784f390/cartempty.glb';
  const filledUrl = 'https://cdn.shopify.com/3d/models/cbb0df0c73e05bb9/cartadded.glb';

  let cartCount = Number(cartLink.dataset.cartCount || 0);
  let currentModel = null;
  let mixer = null;
  let action = null;
  let filledPlayed = false;

  const scene = new THREE.Scene();

  const camera = new THREE.PerspectiveCamera(35, 1, 0.1, 100);
  camera.position.set(0, 0, 3);

  const renderer = new THREE.WebGLRenderer({
    canvas,
    alpha: true,
    antialias: true,
    powerPreference: 'low-power'
  });

  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  renderer.outputColorSpace = THREE.SRGBColorSpace;

  const ambient = new THREE.AmbientLight(0xffffff, 1.1);
  scene.add(ambient);

  const key = new THREE.DirectionalLight(0xffffff, 1.2);
  key.position.set(2, 3, 4);
  scene.add(key);

  const loader = new GLTFLoader();
  const clock = new THREE.Clock();

  function resize() {
    const rect = canvas.getBoundingClientRect();
    const size = Math.max(1, Math.min(rect.width || 54, rect.height || 54));

    renderer.setSize(size, size, false);
    camera.aspect = 1;
    camera.updateProjectionMatrix();
  }

  function fitModel(model, mode) {
    const box = new THREE.Box3().setFromObject(model);
    const size = box.getSize(new THREE.Vector3());
    const center = box.getCenter(new THREE.Vector3());

    model.position.x -= center.x;
    model.position.y -= center.y;
    model.position.z -= center.z;

    const maxDim = Math.max(size.x, size.y, size.z) || 1;

    const targetSize = mode === 'filled' ? 1.30 : 1.00;

    model.scale.setScalar(targetSize / maxDim);

    /* fine tune vertical position */
    if (mode === 'filled') {
      model.position.y += 0.15;
    } else {
      model.position.y += 0;
    }
  }

  function clearModel() {
    if (!currentModel) return;

    scene.remove(currentModel);

    currentModel.traverse((obj) => {
      if (obj.geometry) obj.geometry.dispose();

      if (obj.material) {
        const mats = Array.isArray(obj.material) ? obj.material : [obj.material];
        mats.forEach((mat) => mat.dispose && mat.dispose());
      }
    });

    currentModel = null;
    mixer = null;
    action = null;
  }

  function loadCartModel(url, mode) {
    const isSwap = !!currentModel;

    if (isSwap) {
      cartLink.classList.add('is-switching');
    }

    loader.load(
      url,
      (gltf) => {
        clearModel();

        currentModel = gltf.scene;
        fitModel(currentModel, mode);
        scene.add(currentModel);

        mixer = null;
        action = null;

        if (gltf.animations && gltf.animations.length) {
          mixer = new THREE.AnimationMixer(currentModel);
          action = mixer.clipAction(gltf.animations[0]);

          if (mode === 'empty') {
            action.setLoop(THREE.LoopRepeat, Infinity);
            action.play();
          }

          if (mode === 'filled') {
            action.reset();
            action.setLoop(THREE.LoopRepeat, 2);
            action.clampWhenFinished = true;
            action.play();

            filledPlayed = true;
          }
        }

        cartLink.classList.add('is-glb-ready');
        cartLink.classList.toggle('has-items', cartCount > 0);

        if (badge) {
          badge.textContent = String(cartCount);
        }

        if (isSwap) {
          requestAnimationFrame(() => {
            cartLink.classList.remove('is-switching');
          });
        }
      },
      undefined,
      () => {
        cartLink.classList.remove('is-glb-ready');
        cartLink.classList.remove('is-switching');
      }
    );
  }

  function updateCartState(count) {
    cartCount = Number(count || 0);

    cartLink.dataset.cartCount = String(cartCount);
    cartLink.classList.toggle('has-items', cartCount > 0);

    if (badge) {
      badge.textContent = String(cartCount);
    }

    if (cartCount > 0) {
      loadCartModel(filledUrl, 'filled');
    } else {
      filledPlayed = false;
      loadCartModel(emptyUrl, 'empty');
    }
  }

  function tick() {
    const dt = clock.getDelta();

    if (mixer) {
      mixer.update(dt);
    }

    renderer.render(scene, camera);
    requestAnimationFrame(tick);
  }

  resize();
  window.addEventListener('resize', resize, { passive: true });

  updateCartState(cartCount);
  tick();

  window.VDivideCart3D = {
    update: updateCartState
  };
}

document.addEventListener('DOMContentLoaded', initCartGLB);